import { render, staticRenderFns } from "./IntegralRule.vue?vue&type=template&id=dc2f5ec4&scoped=true&"
import script from "./IntegralRule.vue?vue&type=script&lang=js&"
export * from "./IntegralRule.vue?vue&type=script&lang=js&"
import style0 from "./IntegralRule.vue?vue&type=style&index=0&id=dc2f5ec4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2f5ec4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc2f5ec4')) {
      api.createRecord('dc2f5ec4', component.options)
    } else {
      api.reload('dc2f5ec4', component.options)
    }
    module.hot.accept("./IntegralRule.vue?vue&type=template&id=dc2f5ec4&scoped=true&", function () {
      api.rerender('dc2f5ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberCenter/views/activity_management/components/IntegralRule.vue"
export default component.exports